import { Reducer } from 'redux';

import { SetAnalyticsSettingsSelectedUserAction } from '../../domains/analyticsSettings/actions.types';

import { AnalyticsSettings } from './types';

export type AnalyticsSettingsAction = SetAnalyticsSettingsSelectedUserAction;

const initialState: AnalyticsSettings = { selectedOnBehalfOfUserId: undefined };

const reducer: Reducer<AnalyticsSettings, AnalyticsSettingsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'ANALYTICS_SETTING_SELECTED_USER.SET':
      return { selectedOnBehalfOfUserId: action.payload.selectedOnBehalfOfUserId };
    default:
      return state;
  }
};

export default reducer;
